import React, {useState} from 'react'
import {Button, Modal, message} from "antd";
import {DeleteOutlined} from "@ant-design/icons";
import {deleteRole} from "../../services/serviceRole";
import config from "../../config";

const RoleDelete  = ({roleId, updater}) => {
    const [deleteModal, setDeleteModal] = useState(false)

    const handleDeleteClick = (decision) => {
        if(decision && !config.protectedVariables.roleId.includes(roleId)){
            deleteRole(roleId)
                .then(() => {
                    setDeleteModal(!deleteModal)
                    updater()
                })
        }else if(decision && config.protectedVariables.roleId.includes(roleId)){
            message.error('Bu işlem yapılamaz')
        }else {
            setDeleteModal(!deleteModal)
        }
    }

    return(
        <React.Fragment>
            <Button type={'primary'} danger onClick={() => setDeleteModal(!deleteModal)}><DeleteOutlined/></Button>

            <Modal
            open={deleteModal}
            onCancel={() => setDeleteModal(!deleteModal)}
            title={'Silmek istediğinize emin misiniz ?'}
            footer={[
                <Button danger type={'primary'} key={'SubmitButton'} onClick={() => handleDeleteClick(true)} >Onayla</Button>,
                <Button key={'CancelButton'}  onClick={() => handleDeleteClick(false)}>Vazgeç</Button>
            ]}
            >

            </Modal>
        </React.Fragment>
    )
}
export default RoleDelete